<template>
  <div>
    <marketing-pack-order-history-detail v-if="selectedOrderId" :order-id="selectedOrderId" @clear="selectedOrderId = null" />
    <marketing-pack-order-history-index v-else @select-order="selectedOrderId = $event" />
  </div>
</template>

<script>
import MarketingPackOrderHistoryIndex from './order-history/MarketingPackOrderHistoryIndex'
import MarketingPackOrderHistoryDetail from './order-history/MarketingPackOrderHistoryDetail'
import { mapState } from 'vuex'
export default {
  components: {
    MarketingPackOrderHistoryIndex,
    MarketingPackOrderHistoryDetail
  },
  data () {
    return {
      selectedOrderId: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  watch: {
    selectedOffice () {
      this.selectedOrderId = null
    }
  }
}
</script>
